export const initBackLink = () => {
  const backBtn = document.querySelector('[data-article-back]');

  if (backBtn) {
    if (document.referrer && document.referrer !== window.location.href) {
      const referrerUrl = new URL(document.referrer);
      const referrerHandle = referrerUrl.pathname;
      const validHandlesArr = backBtn.dataset.customForPages.split(',') || [];

      if (validHandlesArr.includes(referrerHandle)) {
        backBtn.href = document.referrer;
      }
    }
  }
};
